module.exports = __webpack_public_path__ + "img/file44.0b9c1347.png";